import { css } from '@emotion/css';
import { createElement, SVGProps } from 'react';
import { ReactComponent as ExclamationMark } from './exclamation-mark.svg';
import { ReactComponent as Timeline } from './timeline.svg';

const createIconComponent = (x: typeof Timeline) => {
  return ({
    size = 16,
    color = 'currentColor',
    ...rest
  }: { size?: number | string } & SVGProps<SVGSVGElement>) => {
    return createElement(x, {
      ...rest,
      width: size,
      height: size,
      className: css({
        '> *': {
          fill: 'none',
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: color
        }
      })
    });
  };
};

export const TimelineIcon = createIconComponent(Timeline);
export const ExclamationMarkIcon = createIconComponent(ExclamationMark);
